export default function openWithApp(osCode, scheme, customUrl, packageName, useIntent = true) {
  const intentUrl = `intent://${customUrl}#Intent;scheme=${scheme};package=${packageName};end`;
  const customScheme = `${scheme}://${customUrl}`;
  if (osCode === 'Android') {
    window.location = useIntent ? intentUrl : customScheme;
  } else if (osCode === 'iOS') {
    window.location = customScheme;
  } else {
    alert(`지원하지 않는 플랫폼입니다. (${osCode})`);
  }
}



// WEBPACK FOOTER //
// ./src/utils/openWithAppWithoutInstall.js